/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown>, n: NonNullable<unknown> }} Perks_Trigger_TenureInputs */



/**
* | output |
* | --- |
* | "{days} days in the server" |
*
* @param {Perks_Trigger_TenureInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_trigger_tenure = /** @type {((inputs: Perks_Trigger_TenureInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Trigger_TenureInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") {
		const form = registry.plural("ru", i?.n, {}, true);
		if (form === "one") return /** @type {LocalizedString} */ (`${i?.days} день на сервере`);
		if (form === "few") return /** @type {LocalizedString} */ (`${i?.days} дня на сервере`);
		if (form === "many") return /** @type {LocalizedString} */ (`${i?.days} дней на сервере`);
		return /** @type {LocalizedString} */ (`${i?.days} дня на сервере`)
	}
	return /** @type {LocalizedString} */ (`${i?.days} days in the server`)
});